/**
 * Lazy boundary for the operator analytics dashboard (post-release
 * analytics-admin, Stage 6). The ONLY admin file App.tsx imports — AdminView
 * (and its admin.css) load via dynamic import() so the chat/reader bundles are
 * untouched and only /admin pays the cost. Mirrors ConnectionsRoute's pattern.
 */
import { Suspense, lazy, type JSX } from "react";

import type { CorpusRoute } from "../corpus/use-corpus-route";

const AdminView = lazy(() => import("./AdminView"));

export interface AdminRouteProps {
  route: CorpusRoute;
  navigate: (to: string) => void;
}

export function AdminRoute(props: AdminRouteProps): JSX.Element {
  return (
    <Suspense fallback={<div className="ad-loading">Cargando panel…</div>}>
      <AdminView navigate={props.navigate} anchor={props.route.anchor} />
    </Suspense>
  );
}
